export const routes = {
    login: "/login",
    register: "/register",
    invoices: "/invoices",
    invoicesDetails: "/invoices/:invoiceId/",
    invoicesAddNew: "/invoices/add_new/",
    suppliers: "/suppliers",
    shipments: "/shipments",
    shipmentsAddNew: "/shipments/add_new",
    orders: "/orders",
    ordersDetails: "/orders/:orderId/",
    ordersAddNew: "/orders/add_new/",
    users: "/users",
    profile: "/profile",
    machinery: "/machinery/list",
    machinery_admin: "/machinery_admin",
    machinery_admin_map: "/machinery_admin_map",
    addNewMachinery: "/machinery/list/add_new",
    machineryDetails: "/machinery/list/:machineryId/",
    machineryProblems: "/machinery/problems/",
    machineryProblemDetails: "/machinery/problems/:problemId/",
    machineryAddProblem: "/machinery/add_problem/:machineryId/",
    machineryTasks: "/machinery/tasks",
    machineryTaskDetails: "/machinery/tasks/:taskId/",
    machineryAddTask: "/machinery/tasks/add_task/:machineryId/",
    machineryComments: "/machinery/comments/",
    machineryMaintenance: "/machinery/maintenance/",
    technicalLiterature: "/technical_literature/",
    errorCode: "/error_code/",
    errorCodeAddNew: "/error_code/add_new",
    map: "/map",
    mapGl: "/map_gl",
    mapHistory: "/map_history",
    mapHistoryGl: "/map_history_gl",
    trackers: "/trackers",
    clients: "/clients",
    tariffs: "/tariffs",
    machinery_telemetry: "/machinery_telemetry",
    fleetDashboard: "/fleet",
    ml_monitor: "/ml_monitor",
    forgotPassword: "/forgot_password",
    driving_events: "/driving_events",
    clientInvoices: "/client_invoices",
    registerByInvite: '/register-by-invite',
    backup: '/backup',
    legalPrivacy: '/legal/privacy',
    legalConsent: '/legal/consent',
    legalTerms: '/legal/terms',
    legalCookies: '/legal/cookies',
    // ── Диспетчеризация ──
    dispatch: '/dispatch',
    driverDay: '/driver',
    share: '/share/:token',
    // Гостевая ссылка на группу техники. Три сегмента, а не два: путь
    // /share/:token уже занят публичным отслеживанием рейса, и react-router
    // ранжирует статический сегмент выше параметра — конфликта нет.
    shareGroup: '/share/group/:token',
    // Старый путь отчёта. Оставлен ради ссылок и кнопки «Отчёт» в диалоге
    // групп — редиректит на /reports/groups?group=<id>.
    machineryGroupReport: '/machinery/groups/:groupId/report',
    /** Отчёты по группам техники — пункт бокового меню. */
    groupReports: '/reports/groups',
};
